import React from 'react';
import { number } from 'prop-types';

import { formatPercentage } from '@ajaibid/utils';
import { Typography } from '@ajaibid/components';

import { getTickerStyle } from './helpers';
import { styPriceChangeTicker } from './style';

const MfReturnTicker = (props) => {
  const { percentage, ...rest } = props;

  const { color, icon } = getTickerStyle(percentage);

  return (
    <Typography
      className={styPriceChangeTicker(icon)}
      type="label"
      size="xs"
      color={color}
      margin={0}
      {...rest}
    >
      {formatPercentage(percentage, 2, { sign: true })}
    </Typography>
  );
};

MfReturnTicker.propTypes = {
  percentage: number,
};

MfReturnTicker.defaultProps = {
  percentage: 0,
};

export default MfReturnTicker;
